import { z } from 'zod';

/**
 * Schema de validação para criação/edição de horários semanais
 */
export const weeklyOperatingHoursFormSchema = z
  .object({
    dayOfWeek: z.number().int().min(0).max(6),
    isClosed: z.boolean().default(false),
    startTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    endTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    hasLunchBreak: z.boolean().default(false),
    lunchStartTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    lunchEndTime: z.string().regex(/^\d{2}:\d{2}$/, 'Formato inválido (use HH:mm)').optional().or(z.literal('')),
    timeInterval: z.number().refine((val) => [15, 30, 45, 60].includes(val), 'Intervalo inválido').optional(),
    parallelAppointments: z.number().int().min(1, 'Mínimo 1 atendimento').max(10, 'Máximo 10 atendimentos').optional(),
    isActive: z.boolean().default(true),
  })
  .refine(
    (data) => data.isClosed || (!!data.startTime && !!data.endTime && !!data.timeInterval),
    { message: 'Horários são obrigatórios quando loja não está fechada', path: ['startTime'] }
  )
  .refine(
    (data) => !data.startTime || !data.endTime || data.startTime < data.endTime,
    { message: 'Horário de início deve ser anterior ao fim', path: ['endTime'] }
  )
  .refine(
    (data) => !data.hasLunchBreak || (!!data.lunchStartTime && !!data.lunchEndTime),
    { message: 'Horários de almoço são obrigatórios quando ativado', path: ['lunchStartTime'] }
  )
  .refine(
    (data) => {
      if (
        data.hasLunchBreak &&
        data.startTime &&
        data.endTime &&
        data.lunchStartTime &&
        data.lunchEndTime
      ) {
        return (
          data.startTime < data.lunchStartTime &&
          data.lunchStartTime < data.lunchEndTime &&
          data.lunchEndTime < data.endTime
        );
      }
      return true;
    },
    { message: 'Intervalo de almoço deve estar dentro do expediente', path: ['lunchEndTime'] }
  );

/**
 * Schema para query de horários semanais
 */
export const weeklyOperatingHoursQuerySchema = z.object({
  storeId: z.string().uuid(),
  dayOfWeek: z.coerce.number().int().min(0).max(6).optional(),
});

export type WeeklyOperatingHoursFormData = z.infer<typeof weeklyOperatingHoursFormSchema>;
export type WeeklyOperatingHoursQueryData = z.infer<typeof weeklyOperatingHoursQuerySchema>;
